<template>
  <v-card>
    <v-card-title>
      <span class="headline"
        >Notificar pedido: {{ $_str_pad_left(pedido.id) }}</span
      >
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-autocomplete
              v-model="users_select"
              :items="items_users"
              :loading="is_loading_users"
              :search-input.sync="search"
              hide-no-data
              hide-selected
              chips
              item-text="nombre_completo"
              item-value="id"
              label="Notificar pedido a:"
              placeholder="Nombre del usuario"
              prepend-icon="mdi-database-search"
              return-object
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="$emit('form:close')">
        Cancelar
      </v-btn>
      <v-btn
        color="blue darken-1"
        :loading="is_submit"
        :disabled="!hasPhone"
        dark
        @click="makeNotify"
      >
        Notificar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import EventBus from "@/EventBus";

export default {
  name: "FormNotifyVendedor",
  mounted() {
    if (this.pedido.repartidor) {
      this.items_users.push(this.pedido.repartidor);
      this.users_select = this.pedido.repartidor;
    }
  },
  props: {
    pedido: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      is_submit: false,
      usuario_id: 0,
      items_users: [],
      is_loading_users: false,
      users_select: [],
      search: "",
    };
  },
  computed: {
    hasPhone() {
      if (this.users_select) {
        return this.users_select.telefono ? true : false;
      }
      return false;
    },
  },
  watch: {
    search(val) {
      /*window.console.log(val, typeof (val), '------')*/
      // Items have already been requested
      if (
        this.is_loading_users ||
        typeof val !== "string" ||
        (typeof val === "string" && val.length < 1)
      )
        return;

      this.is_loading_users = true;

      // Lazily load input items
      axios
        .get("/api/usuarios/repartidores-listar", {
          params: { is_list: 1, search: this.search, type_user: 6 },
        })
        .then((res) => {
          const { data } = res;

          this.is_loading_users = false;
          this.items_users = data;
        })
        .catch(() => {
          this.is_loading_users = false;
          EventBus.$emit("tugarrafon:show-snackbar", {
            text_content: "Error durante la petición. Intenta nuevamente",
          });
        });
    },
    users_select(val) {
      if (val.length < 1) {
        return;
      }
      this.$emit("selected", this.users_select);
    },
  },
  methods: {
    makeNotify() {
      let direccion = "";
      let condiciones = "";

      if (this.pedido.anonimo) {
        direccion = this.pedido.anonimo_detalles.direccion.direccion;
        condiciones = this.pedido.anonimo_detalles.direccion.observaciones
          ? this.pedido.anonimo_detalles.direccion.observaciones
          : "";
      } else {
        direccion = this.pedido.direccion.direccion;
        condiciones = this.pedido.direccion.observaciones
          ? this.pedido.direccion.observaciones
          : "NA";
      }

      let notify = {
        text: `Pedido: *${this.pedido.id}* \nDirección: *${direccion}* \nCondiciones de entrega: *${condiciones}*`,
        phone: this.users_select.telefono.replace(/\D/g, ""),
      };
      notify.text += "\n_Detalles del pedido:_";
      this.pedido.pedido_detalles.map((item) => {
        notify.text += `\nCant: *${item.cantidad}* :: Prod: *${item.producto.nombre}* `;
      });
      notify.text +=
        `\nTotal:*_` +
        this.$_currency(this.pedido.total) +
        `_*\nPago pendiente:*_` +
        this.$_currency(this.pedido.pago_pendiente) +
        "_*";

      this.$emit("form:save", notify);
    },
  },
};
</script>

<style scoped></style>
